"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useReducer, useContext, ReactNode } from "react";
import { initialState, ecomReducer } from "./reducer";
interface EcomProviderProps {
  children: ReactNode;
}
import type { Dispatch } from "react";
import type { EcomState, EcomAction } from "./reducer";
type EcomContextType = [EcomState, Dispatch<EcomAction>];
export const EcomContext = createContext<EcomContextType | undefined>(undefined);
export const useEcomStore = () => {
  return useContext(EcomContext);
};
export function EcomProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [state, dispatch] = useReducer(ecomReducer, initialState);
  let t1;
  if ($[0] !== state) {
    t1 = [state, dispatch];
    $[0] = state;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <EcomContext.Provider value={t1}>{children}</EcomContext.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}